import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {CreateBulkClientBillToInput} from './__generated__/CreateBulkClientBillToMutation.graphql';
import {createRangeBulkAddUpdater} from '../../relay-helpers/RelayCacheHelpers';

const mutation = graphql`
	mutation CreateBulkClientBillToMutation($input: CreateBulkClientBillToInput!) {
		createBulkClientBillTo(input: $input) {
			billTos {
				node {
					id
					clientId
					billFrom {
						id
					}
					billTo {
						id
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateBulkClientBillToInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Client Bill To', 'Bulk Created', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		updater: createRangeBulkAddUpdater(
			input?.billTos?.[0]?.clientId || '',
			'createBulkClientBillTo',
			'billTos',
			'Client_clientBillTos'
		),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
